<template>
	<div class="mb-4">
		<v-card class="mb-3"
			color="grey lighten-1"
			justify-center>
			<br>

			<div class="text-xs-center mt-3">
				<h2> Wybierz formę prawną </h2>
				<div class="mt-5">
					<ChooseFormComponent
						v-bind:legal-form-type="options.nonGovernmentSector"
						v-bind:legal-form="stepData.legalForm"/>
					<ChooseFormComponent
						v-bind:legal-form-type="options.scienceInstitution"
						v-bind:legal-form="stepData.legalForm"/>
					<ChooseFormComponent
						v-bind:legal-form-type="options.governmentOrganization"
						v-bind:legal-form="stepData.legalForm"/>
					<ChooseFormComponent
						v-bind:legal-form-type="options.territoryIndividual"
						v-bind:legal-form="stepData.legalForm"/>
				</div>
			</div>
			<br><br>

			<v-container class="text-xs-center" v-if="stepData.legalForm.type !== undefined">
				<h2 class="font-weight-bold" v-text="stepData.legalForm.type">
				</h2>
				<h1 class="font-weight-black mb-4" v-text="stepData.legalForm.subtype">
				</h1>
				<v-layout align-center justify-center row>
					<v-flex sm4/>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="nip"
						data-vv-as="NIP"
						:error-messages="vErrors.collect('scope0.nip')"
						v-show="stepData.legalForm !== undefined"
						label="Wprowadź numer NIP *"
						aria-label="label for NIP number"
						for="step-choose-legal-form-component-nip"
						id="step-choose-legal-form-component-nip"
						v-model="stepData.nip"
						data-vv-validate-on="none"
						v-validate="'required|digits:10'"
						data-vv-scope="scope0"
						class="text-xs-center"
						outline>
					</v-text-field>
					<v-flex sm4/>
				</v-layout>
			</v-container>
		</v-card>
		<v-btn to="/home" color="blue">Anuluj</v-btn>
		<v-btn
			color="primary"
			@click="$emit('step', 2, 'scope0')">
			Dalej
		</v-btn>
	</div>
</template>

<script>
	import ChooseFormComponent from "./ChooseFormComponent";


	export default {

		name: "StepChooseForm",
		inject: ["parentValidator"],

		components: {ChooseFormComponent},

		provide() {
			return {parentValidator: this.$validator};
		},

		created() {
			this.$validator = this.parentValidator;
		},

		data() {
			return {};
		},

		props: {
			stepData: Object,
			options: Object,
		},
	};
</script>

<style scoped>

</style>
